
// import React, { useState, useEffect } from 'react';
// import {
//   Button,
//   TextField,
//   Typography,
//   Container,
//   Box,
//   FormControl,
//   FormHelperText,
//   InputLabel,
//   Select,
//   MenuItem,
//   Alert,
//   Paper
// } from '@mui/material';
// import { useNavigate } from 'react-router-dom';

// const Register = () => {
//   const [showForm, setShowForm] = useState(false);
//   const [searchValue, setSearchValue] = useState('');
//   const [error, setError] = useState('');
//   const [searchLoading, setSearchLoading] = useState(false);
//   const [patientData, setPatientData] = useState(null);
//   const [searchError, setSearchError] = useState('');
//   const [formData, setFormData] = useState({
//     name: '',
//     age: '',
//     address: '',
//     phone: '',
//     ipNumber: '',
//     opNumber: '',
//     internalNumber: '',
//     referredBy: '',
//     referredByDetail: '',
//   });

//   const [errors, setErrors] = useState({});
//   const [duplicateError, setDuplicateError] = useState('');
//   const navigate = useNavigate();

//   const fetchPatientForms = async (patientId) => {
//     setSearchLoading(true);
//     try {
//       const response = await fetch(`${process.env.REACT_APP_API_URL}/api/patient-forms/${patientId}`);
//       if (!response.ok) throw new Error('Failed to fetch patient forms');
//       const data = await response.json();
//       setPatientData(data);
//     } catch (error) {
//       setError(error.message);
//     } finally {
//       setSearchLoading(false);
//     }
//   };

//   // Automatically hide form when user types in revisit input
//   useEffect(() => {
//     if (searchValue.trim() !== '') {
//       setShowForm(false);
//     }
//   }, [searchValue]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
    
//     // Clear duplicate error when user changes the field
//     if ((name === 'phone' || name === 'opNumber') && duplicateError) {
//       setDuplicateError('');
//     }
//   };

//   const validate = () => {
//     const newErrors = {};
//     if (!formData.name) newErrors.name = 'Name is required';
//     if (!formData.age || formData.age < 0) newErrors.age = 'Age must be valid';
//     if (!formData.address) newErrors.address = 'Address is required';
//     if (!formData.phone || !/^\d{10}$/.test(formData.phone))
//       newErrors.phone = 'Phone number must be 10 digits';
//     if (!formData.ipNumber && !formData.opNumber && !formData.internalNumber)
//       newErrors.ipOp = 'At least one of IP, OP, or Internal Number is required';
//     if (!formData.referredBy) newErrors.referredBy = 'Referred By is required';
//     if (
//       (formData.referredBy === 'Doctor' || formData.referredBy === 'Other') &&
//       !formData.referredByDetail
//     )
//       newErrors.referredByDetail = 'Please provide details';

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const checkForDuplicates = async () => {
//     try {
//       // Check for duplicate phone number
//       const phoneCheck = await fetch(
//         `${process.env.REACT_APP_API_URL}/api/check-patient?phone=${formData.phone}`
//       );
      
//       if (phoneCheck.ok) {
//         const phoneResult = await phoneCheck.json();
//         if (phoneResult.exists) {
//           setDuplicateError('This phone number is already registered');
//           return true;
//         }
//       }

//       // Check for duplicate OP number if provided
//       if (formData.opNumber) {
//         const opCheck = await fetch(
//           `${process.env.REACT_APP_API_URL}/api/check-patient?opNumber=${formData.opNumber}`
//         );
        
//         if (opCheck.ok) {
//           const opResult = await opCheck.json();
//           if (opResult.exists) {
//             setDuplicateError('This OP number is already registered');
//             return true;
//           }
//         }
//       }
      
//       return false;
//     } catch (error) {
//       console.error('Error checking duplicates:', error);
//       setDuplicateError('Error checking for duplicates. Please try again.');
//       return true;
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setDuplicateError('');
    
//     if (!validate()) {
//       return;
//     }

//     // Check for duplicates
//     const hasDuplicates = await checkForDuplicates();
//     if (hasDuplicates) {
//       return;
//     }

//     try {
//       const response = await fetch("${process.env.REACT_APP_API_URL}/api/register", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(formData),
//       });

//       if (!response.ok) {
//         const errorData = await response.json();
//         throw new Error(errorData.message || "Failed to save data");
//       }

//       const data = await response.json();
//       console.log("Saved in DB:", data);

//       // Also save to localStorage for immediate access
//       localStorage.setItem('demography', JSON.stringify({
//         ...formData,
//         id: data.data.id
//       }));

//       // ✅ Show success alert
//       window.alert("Registration successful!");

//       // Redirect after success
//       navigate("/demography");
//     } catch (error) {
//       console.error("Error:", error);
//       // ❌ Show error alert
//       window.alert(error.message || "Error while saving data. Please try again.");
//     }
//   };

// // In your Register.js component, update the handleRevisit function:
// const handleRevisit = async () => {
//   if (!searchValue.trim()) {
//     setSearchError('Please enter an IP, OP, or Internal Number');
//     return;
//   }

//   try {
//     setSearchError('');
    
//     // If not found in localStorage, check the database
//     const response = await fetch(`${process.env.REACT_APP_API_URL}/api/patient/${searchValue}`);
    
//     if (response.ok) {
//       const patientData = await response.json();
      
//       // Save to localStorage for future access
//       localStorage.setItem('demography', JSON.stringify(patientData));
      
//       navigate('/demography');
//     } else if (response.status === 404) {
//       setSearchError('No matching record found.');
//     } else {
//       // Try to get error message from response
//       const errorData = await response.json().catch(() => ({}));
//       setSearchError(errorData.message || 'Error searching for patient. Please try again.');
//     }
//   } catch (error) {
//     console.error('Error:', error);
//     setSearchError('Failed to search. Please try again.');
//   }
// };

// // In your Demography.js component, update the handleSearch function:
// const handleSearch = async () => {
//   if (!searchValue.trim()) {
//     setError("Please enter an IP, OP, or Internal Number");
//     return;
//   }

//   try {
//     setSearchLoading(true);
//     setError("");
//     const response = await fetch(`${process.env.REACT_APP_API_URL}/api/patient/${searchValue}`);
    
//     if (response.ok) {
//       const patient = await response.json();
//       setPatientData(patient);
//       localStorage.setItem('demography', JSON.stringify(patient));
//       fetchPatientForms(patient.id || patient.op_number || patient.ip_number);
//     } else if (response.status === 404) {
//       setError("No patient found with that identifier");
//     } else {
//       // Try to get error message from response
//       const errorData = await response.json().catch(() => ({}));
//       setError(errorData.message || "Error searching for patient");
//     }
//   } catch (error) {
//     console.error("Search error:", error);
//     setError("Failed to search for patient");
//   } finally {
//     setSearchLoading(false);
//   }
// };
//   return (
//     <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
//       <Paper elevation={3} sx={{ p: 4, borderRadius: 2 }}>
//         <Typography
//           variant="h4"
//           gutterBottom
//           align="center"
//           sx={{ fontWeight: 'bold', color: '#1565c0', mb: 3 }}
//         >
//           Patient Registration
//         </Typography>

//         {/* Buttons Row */}
//         <Box
//           sx={{
//             display: 'flex',
//             gap: 2,
//             mb: 3,
//             justifyContent: 'space-between',
//             flexWrap: 'wrap',
//             alignItems: 'center',
//           }}
//         >
//           <Button
//             variant="contained"
//             onClick={() => setShowForm(true)}
//             sx={{
//               background: 'linear-gradient(to right, #1565c0, #1e88e5)',
//               fontWeight: 'bold',
//               textTransform: 'none',
//               px: 4,
//               borderRadius: '30px',
//               fontSize: '1rem',
//             }}
//           >
//             New Registration
//           </Button>

//           <Box sx={{ display: 'flex', gap: 1, alignItems: 'flex-start' }}>
//             <TextField
//               placeholder="Enter IP/OP/Internal No"
//               size="small"
//               value={searchValue}
//               onChange={(e) => {
//                 setSearchValue(e.target.value);
//                 setSearchError('');
//               }}
//               error={!!searchError}
//               helperText={searchError}
//               sx={{ width: 220 }}
//             />
//             <Button
//               variant="outlined"
//               onClick={handleRevisit}
//               sx={{
//                 borderColor: '#1565c0',
//                 color: '#1565c0',
//                 fontWeight: 'bold',
//                 textTransform: 'none',
//               }}
//             >
//               Revisit
//             </Button>
//           </Box>
//         </Box>

//         {/* Registration Form */}
//         {showForm && (
//           <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
//             {duplicateError && (
//               <Alert severity="error" sx={{ mb: 2 }}>
//                 {duplicateError}
//               </Alert>
//             )}
            
//             <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
//               <TextField
//                 label="Name *"
//                 name="name"
//                 value={formData.name}
//                 onChange={handleChange}
//                 sx={{ flexGrow: 1, minWidth: 200 }}
//                 margin="normal"
//                 error={!!errors.name}
//                 helperText={errors.name}
//                 required
//               />

//               <TextField
//                 label="Age *"
//                 name="age"
//                 type="number"
//                 value={formData.age}
//                 onChange={handleChange}
//                 sx={{ width: 100 }}
//                 margin="normal"
//                 error={!!errors.age}
//                 helperText={errors.age}
//                 required
//               />
//             </Box>

//             <TextField
//               label="Address *"
//               name="address"
//               value={formData.address}
//               onChange={handleChange}
//               fullWidth
//               margin="normal"
//               error={!!errors.address}
//               helperText={errors.address}
//               required
//             />

//             <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
//               <TextField
//                 label="Phone Number *"
//                 name="phone"
//                 value={formData.phone}
//                 onChange={handleChange}
//                 sx={{ flexGrow: 1, minWidth: 200 }}
//                 margin="normal"
//                 error={!!errors.phone}
//                 helperText={errors.phone || "10 digits required"}
//                 required
//               />

//               <TextField
//                 label="OP Number"
//                 name="opNumber"
//                 value={formData.opNumber}
//                 onChange={handleChange}
//                 sx={{ flexGrow: 1, minWidth: 150 }}
//                 margin="normal"
//               />
//             </Box>

//             <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
//               <TextField
//                 label="IP Number"
//                 name="ipNumber"
//                 value={formData.ipNumber}
//                 onChange={handleChange}
//                 sx={{ flexGrow: 1, minWidth: 150 }}
//                 margin="normal"
//               />

//               <TextField
//                 label="Internal Number"
//                 name="internalNumber"
//                 value={formData.internalNumber}
//                 onChange={handleChange}
//                 sx={{ flexGrow: 1, minWidth: 150 }}
//                 margin="normal"
//               />
//             </Box>

//             <FormControl
//               fullWidth
//               margin="normal"
//               error={!!errors.referredBy}
//               required
//             >
//               <InputLabel>Referred By *</InputLabel>
//               <Select
//                 name="referredBy"
//                 value={formData.referredBy}
//                 onChange={handleChange}
//                 label="Referred By *"
//               >
//                 <MenuItem value="Doctor">Doctor</MenuItem>
//                 <MenuItem value="Self">Self</MenuItem>
//                 <MenuItem value="Other">Other</MenuItem>
//               </Select>
//               <FormHelperText>{errors.referredBy}</FormHelperText>
//             </FormControl>

//             {(formData.referredBy === 'Doctor' ||
//               formData.referredBy === 'Other') && (
//                 <TextField
//                   label={`Please specify ${formData.referredBy.toLowerCase()} *`}
//                   name="referredByDetail"
//                   value={formData.referredByDetail}
//                   onChange={handleChange}
//                   fullWidth
//                   margin="normal"
//                   error={!!errors.referredByDetail}
//                   helperText={errors.referredByDetail}
//                   required
//                 />
//               )}

//             <Box sx={{ display: 'flex', gap: 2, mt: 3 }}>
//               <Button
//                 variant="contained"
//                 color="primary"
//                 type="submit"
//                 sx={{ px: 4, fontWeight: 'bold' }}
//               >
//                 Register
//               </Button>
//               <Button
//                 variant="outlined"
//                 color="secondary"
//                 onClick={() => setShowForm(false)}
//               >
//                 Cancel
//               </Button>
//             </Box>
//           </Box> 
//         )}
//       </Paper>
//     </Container>
//   );
// };

// export default Register;


import React, { useState, useEffect } from 'react';
import {
  Button,
  TextField,
  Typography,
  Container,
  Box,
  FormControl,
  FormHelperText,
  InputLabel,
  Select,
  MenuItem,
  Alert,
  Paper,
  CircularProgress,
  Snackbar
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

const Register = () => {
  const [showForm, setShowForm] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const [error, setError] = useState('');
  const [searchLoading, setSearchLoading] = useState(false);
  const [patientData, setPatientData] = useState(null);
  const [searchError, setSearchError] = useState('');
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  const [formData, setFormData] = useState({
    name: '',
    age: '',
    address: '',
    phone: '',
    ipNumber: '',
    opNumber: '',
    referredBy: '',
    referredByDetail: '',
  });

  const [errors, setErrors] = useState({});
  const [duplicateError, setDuplicateError] = useState('');
  const navigate = useNavigate();

  const showSnackbar = (message, severity = 'success') => {
    setSnackbar({ open: true, message, severity });
  };

  // Automatically hide form when user types in revisit input
  useEffect(() => {
    if (searchValue.trim() !== '') {
      setShowForm(false);
    }
  }, [searchValue]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    
    // Clear duplicate error when user changes the field
    if ((name === 'phone' || name === 'opNumber') && duplicateError) {
      setDuplicateError('');
    }
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.name) newErrors.name = 'Name is required';
    if (!formData.age || formData.age < 0) newErrors.age = 'Age must be valid';
    if (!formData.address) newErrors.address = 'Address is required';
    if (!formData.phone || !/^\d{10}$/.test(formData.phone))
      newErrors.phone = 'Phone number must be 10 digits';
    if (!formData.ipNumber && !formData.opNumber)
      newErrors.ipOp = 'At least one of IP or OP Number is required';
    if (!formData.referredBy) newErrors.referredBy = 'Referred By is required';
    if (
      (formData.referredBy === 'Doctor' || formData.referredBy === 'Other') &&
      !formData.referredByDetail
    )
      newErrors.referredByDetail = 'Please provide details';

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const checkForDuplicates = async () => {
    try {
      // Check for duplicate phone number
      const phoneCheck = await fetch(
        `${process.env.REACT_APP_API_URL}/api/check-patient?phone=${formData.phone}`
      );
      
      if (phoneCheck.ok) {
        const phoneResult = await phoneCheck.json();
        if (phoneResult.exists) {
          setDuplicateError('This phone number is already registered');
          return true;
        }
      }

      // Check for duplicate OP number if provided
      if (formData.opNumber) {
        const opCheck = await fetch(
          `${process.env.REACT_APP_API_URL}/api/check-patient?opNumber=${formData.opNumber}`
        );
        
        if (opCheck.ok) {
          const opResult = await opCheck.json();
          if (opResult.exists) {
            setDuplicateError('This OP number is already registered');
            return true;
          }
        }
      }
      
      return false;
    } catch (error) {
      console.error('Error checking duplicates:', error);
      setDuplicateError('Error checking for duplicates. Please try again.');
      return true;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDuplicateError('');
    
    if (!validate()) {
      return;
    }

    // Check for duplicates
    const hasDuplicates = await checkForDuplicates();
    if (hasDuplicates) {
      return;
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/register`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to save data");
      }

      const data = await response.json();
      console.log("Saved in DB:", data);

      // Also save to localStorage for immediate access
      localStorage.setItem('demography', JSON.stringify({
        ...formData,
        id: data.data.id
      }));

      // Show success message
      showSnackbar("Registration successful!", 'success');

      // Reset form
      setFormData({
        name: '',
        age: '',
        address: '',
        phone: '',
        ipNumber: '',
        opNumber: '',
        referredBy: '',
        referredByDetail: '',
      });
      setShowForm(false);

      // Redirect after success
      setTimeout(() => {
        navigate("/demography");
      }, 1500);
    } catch (error) {
      console.error("Error:", error);
      showSnackbar(error.message || "Error while saving data. Please try again.", 'error');
    }
  };

  // Fixed revisit function - only searches by IP/OP number
  const handleRevisit = async () => {
    if (!searchValue.trim()) {
      setSearchError('Please enter an IP or OP Number');
      return;
    }

    try {
      setSearchLoading(true);
      setSearchError('');
      
      console.log('🔍 Searching for patient:', searchValue);
      
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/revisit-patient/${encodeURIComponent(searchValue)}`);
      
      if (response.ok) {
        const patientData = await response.json();
        console.log('✅ Patient found:', patientData);
        
        // Save to localStorage for future access
        localStorage.setItem('demography', JSON.stringify(patientData));
        
        // Clear search field
        setSearchValue('');
        
        showSnackbar(`Patient ${patientData.name} found successfully!`, 'success');
        
        // Navigate to demography page after a short delay
        setTimeout(() => {
          navigate('/demography');
        }, 1000);
      } else {
        const errorData = await response.json();
        console.error('❌ Server error:', errorData);
        
        if (response.status === 404) {
          setSearchError(errorData.message || 'No matching record found.');
        } else if (response.status === 400) {
          setSearchError(errorData.message || 'Invalid search parameter.');
        } else {
          setSearchError(errorData.message || 'Error searching for patient. Please try again.');
        }
        
        showSnackbar(errorData.message || 'Error searching for patient', 'error');
      }
    } catch (error) {
      console.error('❌ Error in handleRevisit:', error);
      setSearchError('Failed to search. Please check your connection and try again.');
      showSnackbar('Network error. Please check your connection.', 'error');
    } finally {
      setSearchLoading(false);
    }
  };

  return (
    <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
      <Paper elevation={3} sx={{ p: 4, borderRadius: 2 }}>
        <Typography
          variant="h4"
          gutterBottom
          align="center"
          sx={{ fontWeight: 'bold', color: '#1565c0', mb: 3 }}
        >
          Patient Registration
        </Typography>

        {/* Buttons Row */}
        <Box
          sx={{
            display: 'flex',
            gap: 2,
            mb: 3,
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            alignItems: 'center',
          }}
        >
          <Button
            variant="contained"
            onClick={() => {
              setShowForm(true);
              setSearchValue(''); // Clear search when showing form
              setSearchError(''); // Clear any search errors
            }}
            sx={{
              background: 'linear-gradient(to right, #1565c0, #1e88e5)',
              fontWeight: 'bold',
              textTransform: 'none',
              px: 4,
              borderRadius: '30px',
              fontSize: '1rem',
            }}
          >
            New Registration
          </Button>

          <Box sx={{ display: 'flex', gap: 1, alignItems: 'flex-start' }}>
            <TextField
              placeholder="Enter IP/OP Number"
              size="small"
              value={searchValue}
              onChange={(e) => {
                setSearchValue(e.target.value);
                setSearchError('');
              }}
              onKeyPress={(e) => {
                if (e.key === 'Enter') {
                  handleRevisit();
                }
              }}
              error={!!searchError}
              helperText={searchError}
              sx={{ width: 220 }}
              disabled={searchLoading}
            />
            <Button
              variant="outlined"
              onClick={handleRevisit}
              disabled={searchLoading}
              sx={{
                borderColor: '#1565c0',
                color: '#1565c0',
                fontWeight: 'bold',
                textTransform: 'none',
                minWidth: '100px',
              }}
            >
              {searchLoading ? <CircularProgress size={24} /> : 'Revisit'}
            </Button>
          </Box>
        </Box>

        {/* Registration Form */}
        {showForm && (
          <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
            {duplicateError && (
              <Alert severity="error" sx={{ mb: 2 }}>
                {duplicateError}
              </Alert>
            )}
            
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
              <TextField
                label="Name *"
                name="name"
                value={formData.name}
                onChange={handleChange}
                sx={{ flexGrow: 1, minWidth: 200 }}
                margin="normal"
                error={!!errors.name}
                helperText={errors.name}
                required
              />

              <TextField
                label="Age *"
                name="age"
                type="number"
                value={formData.age}
                onChange={handleChange}
                sx={{ width: 100 }}
                margin="normal"
                error={!!errors.age}
                helperText={errors.age}
                required
              />
            </Box>

            <TextField
              label="Address *"
              name="address"
              value={formData.address}
              onChange={handleChange}
              fullWidth
              margin="normal"
              error={!!errors.address}
              helperText={errors.address}
              required
            />

            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
              <TextField
                label="Phone Number *"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                sx={{ flexGrow: 1, minWidth: 200 }}
                margin="normal"
                error={!!errors.phone}
                helperText={errors.phone || "10 digits required"}
                required
              />

              <TextField
                label="OP Number"
                name="opNumber"
                value={formData.opNumber}
                onChange={handleChange}
                sx={{ flexGrow: 1, minWidth: 150 }}
                margin="normal"
              />
            </Box>

            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
              <TextField
                label="IP Number"
                name="ipNumber"
                value={formData.ipNumber}
                onChange={handleChange}
                sx={{ flexGrow: 1, minWidth: 150 }}
                margin="normal"
              />
            </Box>

            <FormControl
              fullWidth
              margin="normal"
              error={!!errors.referredBy}
              required
            >
              <InputLabel>Referred By *</InputLabel>
              <Select
                name="referredBy"
                value={formData.referredBy}
                onChange={handleChange}
                label="Referred By *"
              >
                <MenuItem value="Doctor">Doctor</MenuItem>
                <MenuItem value="Self">Self</MenuItem>
                <MenuItem value="Other">Other</MenuItem>
              </Select>
              <FormHelperText>{errors.referredBy}</FormHelperText>
            </FormControl>

            {(formData.referredBy === 'Doctor' ||
              formData.referredBy === 'Other') && (
                <TextField
                  label={`Please specify ${formData.referredBy.toLowerCase()} *`}
                  name="referredByDetail"
                  value={formData.referredByDetail}
                  onChange={handleChange}
                  fullWidth
                  margin="normal"
                  error={!!errors.referredByDetail}
                  helperText={errors.referredByDetail}
                  required
                />
              )}

            <Box sx={{ display: 'flex', gap: 2, mt: 3 }}>
              <Button
                variant="contained"
                color="primary"
                type="submit"
                sx={{ px: 4, fontWeight: 'bold' }}
              >
                Register
              </Button>
              <Button
                variant="outlined"
                color="secondary"
                onClick={() => {
                  setShowForm(false);
                  setFormData({
                    name: '',
                    age: '',
                    address: '',
                    phone: '',
                    ipNumber: '',
                    opNumber: '',
                    referredBy: '',
                    referredByDetail: '',
                  });
                  setErrors({});
                  setDuplicateError('');
                }}
              >
                Cancel
              </Button>
            </Box>
          </Box> 
        )}
      </Paper>

      {/* Snackbar for notifications */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        message={snackbar.message}
        severity={snackbar.severity}
      />
    </Container>
  );
};

export default Register;